import { render, staticRenderFns } from "./ArticleCategoriesDashboard.vue?vue&type=template&id=046b0451&"
import script from "./ArticleCategoriesDashboard.vue?vue&type=script&lang=js&"
export * from "./ArticleCategoriesDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports